export const CUURENT_VERSION = 2;
export const TT_BACKGROUND = 'rgb(0, 55, 106)';
export const OPTIONS_KEY = 'TT OPTIONS';
export const CORNERS = 'CORNERS';
export const SIDES = 'SIDES';
export const TT_RED = 'rgb(129, 0, 0)';
export const TT_YELLOW = 'rgb(128, 128, 0)';
export const TT_GREEN = 'rgb(0, 98, 0)';
export const TT_BLUE = 'rgb(0, 4, 255)';
export const TT_PURPLE = 'rgb(77, 2, 117)';
export const SPIN_DURATION = 1000;
export const FLIP_DURATION = 500;
export const HELPED_KEY = 'TT HELPED';
export const YOUTUBE_TT = 'https://youtu.be/Kv3BgeLpGFs';
